import { getContextLimit } from "../utils/memoryContextUtils";
import { LocalStorageKey } from "./types";
export const LOCAL_STORAGE_KEYS_TO_CONVERT = [
    LocalStorageKey.INFERENCE_MODEL,
    LocalStorageKey.INFERENCE_MAX_NEW_TOKENS,
    LocalStorageKey.INFERENCE_TEMPERATURE,
    LocalStorageKey.INFERENCE_TOP_P,
    LocalStorageKey.INFERENCE_TOP_K,
    LocalStorageKey.CONVIMAGE_MODELSTYLE,
    LocalStorageKey.CONVIMAGE_NSFWMODE,
    LocalStorageKey.CONVIMAGE_LORASCALE,
    LocalStorageKey.FIRST_TIME_WAITING_QUEUE_MODAL,
    LocalStorageKey.AVATAR_GENERATE_RETRY_AFTER,
    LocalStorageKey.CHARACTER_RATINGS,
    LocalStorageKey.DRAFT_LOCAL_STORAGE,
    LocalStorageKey.TAG_SUGGESTION,
    LocalStorageKey.LAST_TIME_FILTERED_CHARACTERS,
];
export var MemoryConstants;
(function (MemoryConstants) {
    MemoryConstants["Memory16K"] = "16K";
    MemoryConstants["Memory8K"] = "8K";
    MemoryConstants["Memory4K"] = "4K";
    MemoryConstants["Memory3K"] = "3K";
    MemoryConstants["Memory2K"] = "2K";
})(MemoryConstants || (MemoryConstants = {}));
const CONTEXT_16K = 16;
const CONTEXT_8K = 8;
const CONTEXT_4K = 4;
const CONTEXT_3K = 3;
const CONTEXT_2K = 2;
export var AvailableMemory;
(function (AvailableMemory) {
    AvailableMemory[AvailableMemory["AvailableMemory16384"] = getContextLimit(CONTEXT_16K)] = "AvailableMemory16384";
    AvailableMemory[AvailableMemory["AvailableMemory8192"] = getContextLimit(CONTEXT_8K)] = "AvailableMemory8192";
    AvailableMemory[AvailableMemory["AvailableMemory4096"] = getContextLimit(CONTEXT_4K)] = "AvailableMemory4096";
    AvailableMemory[AvailableMemory["AvailableMemory3072"] = getContextLimit(CONTEXT_3K)] = "AvailableMemory3072";
    AvailableMemory[AvailableMemory["AvailableMemory2048"] = getContextLimit(CONTEXT_2K)] = "AvailableMemory2048";
})(AvailableMemory || (AvailableMemory = {}));
